module.exports = __webpack_public_path__ + "img/pontagrossa.815cd509.jpg";